import { Component, Inject, OnInit } from '@angular/core';
import {MatDialog, MAT_DIALOG_DATA} from '@angular/material/dialog';

@Component({
  selector: 'app-result',
  templateUrl: './result.component.html',
  styleUrls: ['./result.component.css']
})
export class ResultComponent implements OnInit {

  constructor(@Inject(MAT_DIALOG_DATA) public data: any) {
    this.done=data.done;
    this.declined=data.fail;
  }
  // done:any[]=[];
  declined:any[]=[];
  done: any[] = [
  ];
  ngOnInit(): void {
  }

}
